import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { Input } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FormInput } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Systolic/diastolic blood-pressure field storing a "low/high" string. */
export function BloodPressureField(_ref) {
  var _field$observation;
  var field = _ref.field,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _String$split = String(value !== null && value !== void 0 ? value : "").split("/"),
    _String$split2 = _slicedToArray(_String$split, 2),
    _String$split2$ = _String$split2[0],
    low = _String$split2$ === void 0 ? "" : _String$split2$,
    _String$split2$2 = _String$split2[1],
    high = _String$split2$2 === void 0 ? "" : _String$split2$2;
  var update = function update(part, next) {
    if (next !== "" && !/^[0-9]+$/.test(next)) return;
    var lo = part === "low" ? next : low;
    var hi = part === "high" ? next : high;
    onChange("".concat(lo, "/").concat(hi));
  };
  return /*#__PURE__*/React.createElement(Input.Wrapper, {
    label: t((_field$observation = field.observation) !== null && _field$observation !== void 0 ? _field$observation : ""),
    required: field.required
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(FormInput, {
    className: "w-16",
    inputMode: "numeric",
    maxLength: 3,
    placeholder: "--",
    value: low,
    disabled: disabled,
    onChange: function onChange(event) {
      return update("low", event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.BP_LOW, {
        fieldId: field.id
      });
    },
    "data-testid": "bp-low-".concat(field.id)
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-sds-base-secondary"
  }, "/"), /*#__PURE__*/React.createElement(FormInput, {
    className: "w-16",
    inputMode: "numeric",
    maxLength: 3,
    placeholder: "--",
    value: high,
    disabled: disabled,
    onChange: function onChange(event) {
      return update("high", event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.BP_HIGH, {
        fieldId: field.id
      });
    },
    "data-testid": "bp-high-".concat(field.id)
  }), field.unit ? /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-secondary"
  }, t(field.unit)) : null));
}